<template>
  <div class="register-container">
    <div class="form-container" v-if="notErr">
      <div class="title">{{ game.label }}</div>
      <div class="row">
        <div class="col-label">
          <span>*</span>
          {{ $t('jtRegisterForm.LABEL_USERNAME') }}
        </div>
        <div class="col-content">
          <el-input v-model="username"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          <span>*</span>
          {{ $t('jtRegisterForm.LABEL_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input v-model="password" type="password" show-password></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          <span>*</span>
          {{ $t('jtRegisterForm.LABEL_CONFIRM_PASSWORD') }}
        </div>
        <div class="col-content">
          <el-input
            v-model="confirmPassword"
            type="password"
            show-password
          ></el-input>
        </div>
      </div>
      <div class="row" v-if="hasEmail">
        <div class="col-label">
          <span>*</span>
          {{ $t('jtRegisterForm.LABEL_EMAIL') }}
        </div>
        <div class="col-content">
          <el-tooltip
            :content="$t('jtRegisterForm.EMAIL_TIPS')"
            placement="top-start"
          >
            <el-input v-model="email"></el-input>
          </el-tooltip>
        </div>
      </div>
      <div class="row" v-if="hasEmail && hasConfirmEmail">
        <div class="col-label">
          <span>*</span>
          邮箱确认
        </div>
        <div class="col-content">
          <el-input v-model="confirmEmail"></el-input>
        </div>
      </div>
      <div class="row">
        <div class="col-label">
          <span>*</span>
          {{ zhuti ? zhuti : $t('jtRegisterForm.LABEL_TEAMNAME') }}
        </div>
        <div class="col-content">
          <el-input v-model="teamname"></el-input>
        </div>
      </div>
      <div class="row" v-if="hasCheckCode">
        <div class="col-label">
          <span>*</span>
          {{ $t('jtRegisterForm.CODE') }}
        </div>
        <div class="col-content">
          <el-input v-model="code"></el-input>
        </div>
      </div>
    </div>
    <div class="btn-container" v-if="notErr">
      <el-button
        type="primary"
        :disabled="registerBtnDisabled"
        @click="userSignup"
      >
        <span class="yahei">{{ $t('jtRegisterForm.BTN_SIGNUP') }}</span>
      </el-button>
    </div>
    <div class="errmsg" v-if="!notErr">{{ errMessage }}</div>
    <div class="footer-container">
      <div>
        <router-link :to="loginurl" style="color: #f00">{{
          $t('jtRegisterForm.LABEL_USER_LOGIN')
        }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Validator from '../../../utils/validator.js'
import _ from 'lodash'
import * as storage from '../../../utils/storage'

export default {
  name: 'jtRegisterForm',
  props: {
    game: Object, // 注册的比赛
    tag: String,
    errMessage: { type: String, default: '' },
    zhuti: { type: String, default: '代表队全称' },
  },
  data() {
    return {
      username: '', // 用户名
      password: '', // 密码
      confirmPassword: '', // 密码确认
      teamname: '', // 队名
      email: '', //邮箱
      confirmEmail: '', //确认邮箱
      code: '', //通识码
    }
  },
  computed: {
    registerBtnDisabled() {
      return (
        _.isEmpty(this.username) ||
        _.isEmpty(this.password) ||
        _.isEmpty(this.confirmPassword) ||
        _.isEmpty(this.teamname) ||
        (_.isEmpty(this.email) && !this.game['不需邮箱']) ||
        (_.isEmpty(this.confirmEmail) &&
          !this.game['不需邮箱'] &&
          this.hasConfirmEmail) ||
        (_.isEmpty(this.code) && this.hasCheckCode)
      )
    },

    notErr() {
      return this.errMessage === ''
    },

    hasEmail() {
      return !this.game['不需邮箱']
    },

    hasCheckCode() {
      return !!this.game['通识码']
    },

    hasConfirmEmail() {
      let { host } = window.location
      return storage.getItem('bannerUrl') && host == 'gymnastics.justtool.com'
    },

    loginurl() {
      let str = '/login.html?gameId=' + this.game.id
      return str
    },
  },
  methods: {
    userSignup() {
      try {
        const registerInfo = this.validate()
        this.$emit('signup', registerInfo)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    validate() {
      const gameId = this.game.id
      const username = this.username.trim()
      const password = this.password.trim()
      const confirmPassword = this.confirmPassword.trim()
      const teamname = this.teamname.trim()
      const email = this.email.trim()
      const confirmEmail = this.confirmEmail.trim()
      const code = this.code.trim()

      if (password !== confirmPassword) {
        throw new Error(this.$t('jtRegisterForm.PASSWORD_CONFIRM_DIRTY'))
      }
      if (email !== confirmEmail && this.hasConfirmEmail) {
        throw new Error('确认邮箱与邮箱不一致!')
      }
      if (this.hasEmail) {
        const errMsg = this.$t('email.INCORRECT_EMAIL_FORMAT', { email })
        Validator.isEmail(email, errMsg)
      }

      if (this.hasCheckCode && code != this.game['通识码']) {
        throw new Error(this.$t('jtRegisterForm.CODE_CONFIRM_DIRTY'))
      }

      if (this.tag) {
        return { gameId, username, password, teamname, email, tag: this.tag }
      } else if (this.hasEmail) {
        return { gameId, username, password, teamname, email }
      } else {
        return { gameId, username, password, teamname }
      }
    },
  },

}
</script>

<style lang="stylus">
.register-container {
  min-height: 320px;
  padding: 16px;
  border: 2px solid gray;
  background-color: #f5f5f5;

  .form-container {
    min-height: 240px;
    overflow: auto;
    display: flex;
    flex-direction: column;

    .title {
      line-height: 36px;
      text-align: center;
      font-size: 24px;
      margin-bottom: 10px;
    }

    .row {
      height: 32px;
      line-height: 32px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: row;

      .col-label {
        width: 30%;
        text-align: right;
        padding-right: 10px;

        &:after {
          content: ': ';
        }

        span {
          color: red;
        }
      }

      .col-content input {
        height: 32px;
        line-height: 32px;
        width: 300px;
      }
    }
  }

  .btn-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .el-button {
      font-size: 16px;
      width: 40%;
    }
  }

  .footer-container {
    padding-top: 16px;
    display: flex;
    flex-direction: row-reverse;
  }

  .errmsg {
    font-size: 18px;
    height: 200px;
    margin-top: 50px;
    line-height: 26px;
  }
}

@media screen and (max-width: 768px) {
  .register-container {
    padding: 8px;

    .form-container .title {
      font-size: 18px;
    }

    .form-container .row .col-content input {
      width: 200px;
    }
  }
}
</style>
